import { Map } from "immutable";
import {
  EDIT_SUBTASK_LOADING,
  EDIT_TASK_LOADING,
  EDIT_CALENDAR_EVENT_LOADING,
  RESCHEDULE_EXCEPTION_CALENDAR_EVENT_LOADING,
} from "~/store/action_types";

export function optimisticUpdateResolver(action, state) {
  switch (action.type) {
    case EDIT_TASK_LOADING: {
      const reducer = state.tasks;
      const { taskId } = action;
      if (Map.isMap(reducer)) {
        return reducer.get(`${taskId}`);
      }
      break;
    }
    case EDIT_SUBTASK_LOADING: {
      const reducer = state.subtasks;
      const { id } = action;
      if (reducer && reducer[id]) {
        return reducer[id];
      }
      break;
    }
    case RESCHEDULE_EXCEPTION_CALENDAR_EVENT_LOADING:
    case EDIT_CALENDAR_EVENT_LOADING: {
      const reducer = state.calendarEvents;
      const { id } = action;
      if (reducer && reducer[id]) {
        return reducer[id];
      }
      break;
    }
  }
}
